import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ScanLine, ChevronRight, ShieldCheck } from 'lucide-react';
import { clearLegacyPending } from '../../utils/payMemory';

/** Dashboard entry point for Scan & Pay. */
export default function ScanPayCard({ compact = false, className = '' }) {
  const navigate = useNavigate();
  // The first web version asked "did it go through?" on the dashboard;
  // drop what it left behind so nothing asks again.
  useEffect(() => { clearLegacyPending(); }, []);
  return (
    <>
      <button
        type="button"
        onClick={() => navigate('/scan-pay')}
        className={`w-full flex items-center gap-3 text-left rounded-2xl border transition-all active:scale-[0.99] hover:shadow-sm ${compact ? 'p-2.5' : 'p-3'} ${className}`}
        style={{
          backgroundColor: 'color-mix(in srgb, var(--accent-bg) 7%, white)',
          borderColor: 'color-mix(in srgb, var(--accent-bg) 25%, transparent)'
        }}
      >
        <div
          className={`${compact ? 'w-9 h-9' : 'w-10 h-10'} rounded-xl flex items-center justify-center flex-shrink-0`}
          style={{ backgroundColor: 'var(--accent-bg)', color: 'var(--accent-text)' }}
        >
          <ScanLine className="w-5 h-5" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-bold text-surface-900">Scan & Pay</p>
          <p className="text-xs text-surface-500 truncate flex items-center gap-1">
            <ShieldCheck className="w-3 h-3 text-income-600 flex-shrink-0" />
            Pay any UPI QR. No bank linking.
          </p>
        </div>
        <ChevronRight className="w-4 h-4 text-surface-400 flex-shrink-0" />
      </button>
    </>
  );
}
